module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audio-player"
  }, [(_vm.media.has_preview) ? _c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.media.preview,
      "title": _vm.tooltip
    },
    on: {
      "click": function($event) {
        _vm.play()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('audio', {
    staticClass: "audio-control",
    attrs: {
      "controls": "",
      "autoplay": _vm.autoplay
    }
  }, _vm._l((_vm.media.uris), function(uri) {
    return _c('source', {
      attrs: {
        "src": uri.src,
        "type": uri.mimetype
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5db525ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueAudioplayer.vue
// module id = 47
// module chunks = 0